const path = require('path');
const CLIENT = 'spdk';

module.exports = {
    id: `${CLIENT}`,
    name: 'Superliga.dk',
    salt: 'hi2',
    defaultSCSSPath: path.resolve(__dirname, `../../widgets/themes/${CLIENT}/${CLIENT}.default.scss`),
    themesDir: path.resolve(__dirname, `../../widgets/themes/${CLIENT}/`)
};



/** WEBPACK FOOTER **
 ** ../src/config/clients/spdk.spec.js
 **/